import React from 'react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { UserType } from '../types';
import { useAuthUserContext } from '../providers'
import HLogo from '../images/common/h_logo.png';
import HLogo2x from '../images/common/h_logo@2x.png';

const SubNav = () => {
  const authUser = useAuthUserContext().user;
  const signout = useAuthUserContext().signout;
  const navigate = useNavigate();

  const closeMenu = () => {
    const menuBtnCheck = document.getElementById('menu-btn-check') as HTMLInputElement | null;
    if (menuBtnCheck) {
      menuBtnCheck.checked = false;
    }
  };

  if (authUser?.userType === UserType.Donor) {
    return (
      <>
        <li>
          <Link to="/mypage" className="w_bluebtn" onClick={ closeMenu }>マイページ</Link>
        </li>
        <li>
          <Link to="/mypage/account" className="w_bluebtn" onClick={ closeMenu }>アカウント設定</Link>
        </li>
        <li>
          <button
            className="w_bluebtn"
            type="button"
            onClick={ () => {
              closeMenu();
              signout(() => {
                toast.success('ログアウトしました');
                navigate("/", { replace: true })
              })
            } }
          >
            ログアウト
          </button>
        </li>
      </>
    )
  } else if (authUser?.userType === UserType.Donee) {
    return (
      <>
        <li>
          <Link to="/mypage" className="w_pinkbtn" onClick={ closeMenu }>マイページ</Link>
        </li>
        <li>
          <Link to="/mypage/account" className="w_pinkbtn" onClick={ closeMenu }>アカウント設定</Link>
        </li>
        <li>
          <button
            className="w_pinkbtn"
            type="button"
            onClick={ () => {
              closeMenu();
              signout(() => {
                toast.success('ログアウトしました');
                navigate("/", { replace: true })
              })
            } }
          >
            ログアウト
          </button>
        </li>
      </>
    )
  } else {
    return (
      <>
        <li>
          <Link to="/register" className="w_bluebtn" onClick={ closeMenu }>無料ではじめる</Link>
        </li>
        <li>
          <Link to="/login" className="w_bluebtn" onClick={ closeMenu }>ログイン</Link>
        </li>
        <li>
          <Link to="/search-result" className="orangebtn" onClick={ closeMenu }>ドナーを探す</Link>
        </li>
      </>
    )
  }
}

const TopNav = () => {
  return (
    <div className="h_blc">
      <div className="h_left">
        <h1 className="h_logo">
          <Link to="/">
            <img
              src={ HLogo }
              srcSet={ `${ HLogo } 1x, ${ HLogo2x } 2x` }
              alt="Ton Bébé"
            />
          </Link>
        </h1>
      </div>
      <div className="h_right">
        { /* <!-- ハンバーガーメニュー --> */ }
        <input type="checkbox" id="menu-btn-check" className="smonly" />
        <label htmlFor="menu-btn-check" className="menu-btn smonly"><span></span>
        </label>
        <nav className="menu-content">
          <ul className="h_subnav">
            <SubNav />
          </ul>
          <ul className="smonly">
            <li><Link to="/terms">利用規約</Link></li>
            <li><Link to="/privacy">プライバシーポリシー</Link></li>
            <li><Link to="/cookie_policy">クッキーポリシー</Link></li>
            <li><Link to="/commerce">特定商取引法に基づく表記</Link></li>
            <li><a href="https://note.com/tonbebe">ブログ</a></li>
            <li><Link to="/faq">ヘルプ</Link></li>
          </ul>
        </nav>
        { /* <!--  --> */ }
      </div>
    </div>
  );
}

export default TopNav;
